import { React, useTranslation } from '../..';
import useDateFormat from '../../../../../components/utils/useDateFormat';
import useAppContext from '../../../../../context/useAppContext';

function SessionDate({ date }) {
    const { t } = useTranslation();
    const [{ event }] = useAppContext();

    const [properDate, properTime] = useDateFormat({
        date,
        event,
        dateStyle: 'short',
        timeStyle: 'short'
    });

    return <span>{t('attendees.invitations.summary.date', { start_date: properDate, start_time: properTime })}</span>;
}

export default SessionDate;
